import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { NgxLocalizedNumbers, PriceListProduct } from 'cloud-shared-lib';

@Component({
  selector: 'cutting-product-card',
  styleUrls: ['./product-card.component.scss'],
  templateUrl: './product-card.component.html',
  standalone: true,
  imports: [NgIf, NgxLocalizedNumbers],
})
export class ProductCardComponent {
  @Input() priceListId = 0;
  @Input() product: PriceListProduct;
  @Output() selectedProductChange: EventEmitter<number> = new EventEmitter();

  selectProduct(productId: number): void {
    this.selectedProductChange.emit(productId);
  }

  getProductImagePath(productId: number): string {
    return `${ApiLinks.elasticModelPriceList}/${this.priceListId}/${productId}/preview`;
  }
}
